/* eslint-disable no-unused-vars */
import axios from '@/axios'
import bsApp from '@/jsons-data/mocks/bs_app.json'
import get_bene_point from '@/jsons-data/mocks/get_bene_point.json'

export default {

  getBenePoint() {
    return new Promise((resolve, reject) => {
      // axios.get('/member/point').then(
      //   (response) => {
      //     resolve(response.data)
      //   },  
      //   (error) => {
      //     resolve(bsApp.menuPoint)
      //   }
      // )
      setTimeout(() => {
        resolve(get_bene_point || {})
      }, 500)
    })
  }
}